import HomeBoardLoader from './HomeBoardLoader'
export default HomeBoardLoader
